/* cc-quick-view.js — 24 Sep 2026, direct instruction.

   "A quick preview of the photo without opening in a new page, and allowing
   to scroll thru the different visual... then a button that opens the photo
   page." Every product card in cc-collection-grid.liquid keeps its real
   <a href="product.url"> for SEO and no-JS visitors; this only intercepts a
   click on the IMAGE, opens the shared <dialog>, and fills it from the JSON
   payload the grid already printed server-side - no fetch, no loading flash.

   Motion: opening/closing is wrapped in document.startViewTransition() when
   the browser supports it, with view-transition-name set on the clicked
   card's <img> and the modal's own image just before the swap, so the photo
   itself morphs from its grid position into the preview and back - a real
   shared-element transition, same technique flagged in the 23 Sep audit, just
   applied here instead of a full page navigation. Browsers without support
   get an ordinary instant open/close; nothing regresses.

   Carousel: native CSS scroll-snap (assets/cc-quick-view.css), not a JS
   slider - the standing rule is native over JS wherever native can do the
   job. Dots are horizontal here, deliberately the opposite of the hero fix
   on 23 Sep: the hero dots were moved OFF a horizontal bar because that read
   as an invitation to swipe sideways on a hero that does not page. Here the
   whole point IS "scroll through the different visuals," so a horizontal
   dot row is the correct, honest affordance rather than the wrong one. */
(function () {
  'use strict';

  var dialog = document.getElementById('cc-qv');
  if (!dialog) return; // grid printed no cards, e.g. an empty collection

  var track = dialog.querySelector('.cc-qv__track');
  var dotsWrap = dialog.querySelector('.cc-qv__dots');
  var prevBtn = dialog.querySelector('.cc-qv__arrow--prev');
  var nextBtn = dialog.querySelector('.cc-qv__arrow--next');
  var closeBtn = dialog.querySelector('.cc-qv__close');
  var titleEl = dialog.querySelector('.cc-qv__title');
  var metaEl = dialog.querySelector('.cc-qv__meta');
  var priceEl = dialog.querySelector('.cc-qv__price');
  var buyEl = dialog.querySelector('.cc-qv__buy');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supportsVT = typeof document.startViewTransition === 'function' && !reduceMotion;

  var DATA = {};
  var dataScript = document.getElementById('cc-qv-data');
  if (dataScript) {
    try { DATA = JSON.parse(dataScript.textContent) || {}; } catch (e) { DATA = {}; }
  }

  /* 2026-10-10, same order as the product page, asked for in the same words:
     "first image frame then room then frame alternate colors frame by itself
     and then the room with the matching color frame then the sizes room at
     the end". So each colour contributes its frame-on-a-plain-ground shot
     followed by that same colour hanging in a room, the colours are walked
     in turn, and the size guides go last.

     Unframed has a frame shot and no room, by Charly's decision, so it
     contributes one image and nothing dangles.

     This runs ONCE, on the parsed data, rather than inside populate(), so
     the dot count and the loop clones are built from the ordered list - the
     clones are taken from the ends of p.media, and reordering after they
     were made would have put the wrong photograph either side of the loop.

     Products whose media carry no kind (an older payload, or a product the
     mock-up run has not reached) are left exactly as they are. */
  var QV_ORDER = ['Framed black', 'Framed white', 'Framed natural', 'Unframed'];
  /* The two payloads spell the format differently: the inline one from
     cc-collection-grid says "fmt", the fetched one from product.qv.liquid
     says "format", because it comes through cc-product-image-item. Read
     both or the fetched payload silently sorts into nothing. */
  function qvFmt(m) { return m.fmt || m.format || ''; }
  function orderMedia(list) {
    if (!Array.isArray(list) || !list.length) return list;
    var frames = list.filter(function (m) { return m.kind === 'frame'; });
    if (!frames.length) return list;                       // nothing to pair up
    var rooms = list.filter(function (m) { return m.kind === 'variant-or-room'; });
    var seq = [];
    QV_ORDER.forEach(function (f) {
      var fr = frames.filter(function (m) { return qvFmt(m) === f; })[0];
      if (fr) seq.push(fr);
      var rm = rooms.filter(function (m) { return qvFmt(m) === f; })[0];
      if (rm) seq.push(rm);
    });
    /* anything not placed above keeps its original order behind it: rooms in
       a colour with no frame shot, then guides and plain grounds */
    list.forEach(function (m) { if (seq.indexOf(m) === -1) seq.push(m); });
    return seq;
  }
  Object.keys(DATA).forEach(function (h) {
    if (DATA[h] && DATA[h].media) DATA[h].media = orderMedia(DATA[h].media);
  });

  var opener = null;
  var dotObserver = null;

  function withTransition(name, sourceImg, fn) {
    if (!supportsVT) { fn(); return; }
    // Name the shared element on both ends just for this one transition, then
    // strip it straight after so no other element accidentally reuses it and
    // no stale name lingers on a card that scrolls off and a new one takes
    // its place in the DOM.
    if (sourceImg) sourceImg.style.viewTransitionName = name;
    var t = document.startViewTransition(fn);
    t.finished.finally(function () {
      if (sourceImg) sourceImg.style.viewTransitionName = '';
    });
  }

  /* 2026-09-25: slides carry the same caption as the product page - what
     is on the wall in THAT image (format, print and framed size, the
     furniture for scale, price). Media from the ?view=qv payload has
     src/srcset/cap*; the inline fallback has url only. */
  function buildSlide(media) {
    var fig = document.createElement('figure');
    fig.className = 'cc-qv__slide';
    var img = document.createElement('img');
    img.src = media.src || media.url;
    if (media.srcset) { img.srcset = media.srcset; img.sizes = '(min-width: 960px) 920px, 92vw'; }
    img.alt = media.alt || '';
    img.loading = 'eager';
    img.decoding = 'async';
    fig.appendChild(img);
    if (media.capA || media.capB) {
      var fc = document.createElement('figcaption');
      fc.className = 'cc-qv__cap';
      var txt = document.createElement('span');
      txt.className = 'cc-qv__cap-txt';
      [media.capA, media.capB].forEach(function (t) {
        if (!t) return;
        var sp = document.createElement('span');
        sp.textContent = t;
        txt.appendChild(sp);
      });
      fc.appendChild(txt);
      if (media.price) {
        var b = document.createElement('b');
        b.textContent = media.price;
        fc.appendChild(b);
      }
      fig.appendChild(fc);
      dialog.classList.add('cc-qv--captioned');
    }
    return fig;
  }

  /* On-demand payload: /products/{handle}?view=qv (templates/product.qv.
     liquid). Started on the first touch or hover of a card, so it has
     usually arrived by the time the tap completes; the click waits for it
     at most 350 ms, then falls back to the inline data. */
  var FULL = {};
  function fetchFull(handle) {
    if (FULL[handle]) return FULL[handle];
    FULL[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=qv', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      /* order here too. This payload REPLACES the inline one, so ordering
         only at parse time left the dialog showing the raw gallery whenever
         the fetch won the race - which it does on a warm cache. That is
         exactly how this shipped looking fixed and behaved unfixed. */
      .then(function (t) {
        var d = JSON.parse(t);
        if (d && d.media) d.media = orderMedia(d.media);
        DATA[handle] = d;
        return d;
      })
      .catch(function () { FULL[handle] = null; return null; });
    return FULL[handle];
  }
  function warm(event) {
    var frame = event.target.closest && event.target.closest('[data-qv-handle]');
    if (frame) fetchFull(frame.getAttribute('data-qv-handle'));
  }
  document.addEventListener('pointerdown', warm, { passive: true });
  document.addEventListener('pointerover', warm, { passive: true });

  function populate(handle, sourceImg) {
    var p = DATA[handle];
    if (!p) return false;

    track.innerHTML = '';
    dotsWrap.innerHTML = '';
    dialog.classList.remove('cc-qv--captioned');
    var frag = document.createDocumentFragment();
    p.media.forEach(function (m, i) {
      var slide = buildSlide(m);
      if (i === 0 && supportsVT) slide.querySelector('img').style.viewTransitionName = 'cc-qv-active';
      frag.appendChild(slide);
    });
    track.appendChild(frag);

    var multi = p.media.length > 1;
    /* 2026-09-25: the gallery loops. A copy of the last slide sits before
       the first and a copy of the first after the last; when a swipe
       settles on a copy the track jumps, instantly, to the real slide it
       copies. So a swipe right from the opening image shows the plain
       photograph (always last), and a swipe past the plain photograph
       comes back round to the start. */
    if (multi) {
      var realSlides = track.querySelectorAll('.cc-qv__slide');
      var headClone = realSlides[realSlides.length - 1].cloneNode(true);
      var tailClone = realSlides[0].cloneNode(true);
      [headClone, tailClone].forEach(function (c) {
        c.classList.add('cc-qv__slide--clone');
        c.setAttribute('aria-hidden', 'true');
        var ci = c.querySelector('img');
        if (ci) ci.style.viewTransitionName = '';
      });
      track.insertBefore(headClone, track.firstChild);
      track.appendChild(tailClone);
    }
    prevBtn.hidden = !multi;
    nextBtn.hidden = !multi;
    dotsWrap.hidden = !multi;
    if (multi) {
      p.media.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'cc-qv__dot';
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Photograph ' + (i + 1) + ' of ' + p.media.length);
        d.addEventListener('click', function () { goTo(i, false); });
        dotsWrap.appendChild(d);
      });
      watchDots();
    }

    titleEl.textContent = p.title;
    /* the place links to its collection: Brazil -> the Brazil photographs */
    metaEl.textContent = '';
    if (p.meta && p.metaUrl) {
      var a = document.createElement('a');
      a.href = p.metaUrl;
      a.className = 'cc-place-link';
      a.textContent = p.meta;
      metaEl.appendChild(a);
    } else {
      metaEl.textContent = p.meta || '';
    }
    metaEl.hidden = !p.meta;
    priceEl.textContent = p.price;
    buyEl.href = p.url;

    return true;
  }

  /* real (non-clone) slides, and moving between them */
  function reals() { return track.querySelectorAll('.cc-qv__slide:not(.cc-qv__slide--clone)'); }
  function goTo(i, instant) {
    var r = reals();
    if (!r[i]) return;
    track.scrollTo({ left: r[i].offsetLeft, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
    dotsWrap.querySelectorAll('.cc-qv__dot').forEach(function (d, k) {
      d.classList.toggle('is-active', k === i);
      d.setAttribute('aria-selected', k === i ? 'true' : 'false');
    });
  }
  function currentPos() { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
  /* when the track comes to rest on a clone, swap to the real slide */
  var settleTimer = null;
  function settle() {
    var all = track.querySelectorAll('.cc-qv__slide');
    if (all.length < 3 || !all[0].classList.contains('cc-qv__slide--clone')) return;
    var pos = currentPos();
    var r = reals();
    if (pos <= 0) goTo(r.length - 1, true);
    else if (pos >= all.length - 1) goTo(0, true);
  }
  track.addEventListener('scroll', function () {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(settle, 140);
  }, { passive: true });
  if ('onscrollend' in window) track.addEventListener('scrollend', settle);

  function watchDots() {
    if (dotObserver) dotObserver.disconnect();
    var slides = reals();
    var dots = dotsWrap.querySelectorAll('.cc-qv__dot');
    dotObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio < 0.6) return;
          var idx = Array.prototype.indexOf.call(slides, entry.target);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
        });
      },
      { root: track, threshold: [0.6] }
    );
    slides.forEach(function (s) { dotObserver.observe(s); });
    if (dots[0]) { dots[0].classList.add('is-active'); dots[0].setAttribute('aria-selected', 'true'); }
  }

  function step(dir) {
    var all = track.querySelectorAll('.cc-qv__slide');
    if (all.length < 2) return;
    var target = Math.max(0, Math.min(all.length - 1, currentPos() + dir));
    track.scrollTo({ left: all[target].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    if (reduceMotion) settle();
  }

  var currentHandle = null;
  function open(handle, sourceImg, openerEl) {
    if (!populate(handle, sourceImg)) return; // no data for this handle: let the real link navigate instead
    currentHandle = handle;
    document.documentElement.classList.add('cc-qv-open');
    opener = openerEl;
    withTransition('cc-qv-active', sourceImg, function () {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', ''); // very old browsers: plain block-level fallback via CSS
      goTo(0, true);
      track.focus({ preventScroll: true });
    });
  }

  function close() {
    withTransition('cc-qv-active', null, function () {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    });
    if (opener) { opener.focus(); opener = null; }
    if (dotObserver) { dotObserver.disconnect(); dotObserver = null; }
  }

  // Delegate from the grid: any card image with data-qv-handle opens the
  // preview instead of following its parent <a>. Delegated so it also
  // covers cards a "load more" / pagination interaction adds later.
  document.addEventListener('click', function (event) {
    // the hook lives on .cc-card__frame (plain HTML - no Liquid filter can
    // reliably inject a hyphenated data-attribute onto image_tag's <img>
    // itself), so the click target is the frame; the actual photograph for
    // the view-transition name is its <img> child.
    /* 2026-09-25: the title and price open the preview too, not only the
       photo - any tap on the card. The card is still a real link, so a
       modified click (new tab / window) keeps its native behaviour, and the
       place name under the card is its own link outside the card. */
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var handle = null, img = null, link = null;
    var frame = event.target.closest('[data-qv-handle]');
    if (!frame) {
      var card = event.target.closest('a.cc-card');
      frame = card && card.querySelector('[data-qv-handle]');
    }
    if (frame) {
      handle = frame.getAttribute('data-qv-handle');
      img = frame.querySelector('img');
      link = frame.closest('a');
    } else {
      /* 2026-09-25: search results (theme product cards) and the header
         search dropdown. Any product link in them opens the preview; the
         handle comes from the link itself. */
      var a = event.target.closest('a[href*="/products/"]');
      if (!a) {
        /* a tap on the photo of a theme card lands outside its link; any
           tap in the card counts, except its own buttons and forms */
        var wrap = event.target.closest('.card-wrapper');
        if (wrap && !event.target.closest('button, form, input, select')) a = wrap.querySelector('a[href*="/products/"]');
      }
      if (!a) return;

      /* 2026-10-08, direct instruction: "make sure quick view work on every
         photo click from anywhere on the website".

         This branch used to be gated to `predictive-search, .card-wrapper`,
         so it only ever fired in search results and the header dropdown.
         Every other product link on the site - the homepage Selected tiles
         among them - navigated instead. Rather than hooking each surface
         with data-qv-handle one at a time and missing the next one somebody
         adds, the rule is now general: a click on a PHOTOGRAPH inside a link
         to a product opens the preview.

         Requiring the photograph is what keeps this from being too greedy. A
         text link to a product - a breadcrumb, "view print", a title in a
         list - still navigates, which is what a text link should do.

         Three places are excluded on purpose:
           - cart and cart drawer: tapping a line item's thumbnail means
             "take me back to what I bought", not "show me a gallery"
           - the product page's own gallery: it has its own zoom, and
             opening a preview of the page you are already on is nonsense
           - anything inside a button or form, so Add to cart still adds */
      if (event.target.closest('button, form, input, select, label')) return;
      if (event.target.closest('cart-drawer, #cart, .cart-items, .cart-item, .cart__items, .drawer__cart')) return;
      if (event.target.closest('.cc-pdp__gallery, .product__media, .product__media-wrapper, .cc-qv')) return;
      var photo = event.target.closest('img, picture, svg') || (event.target.tagName === 'IMG' ? event.target : null);
      if (!photo) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      handle = decodeURIComponent(m[1]);
      link = a;
      var holder = a.closest('.card-wrapper, .predictive-search__list-item') || a;
      img = (photo && photo.tagName === 'IMG' ? photo : null) || holder.querySelector('img') || a.querySelector('img');
    }
    if (!handle) return;
    event.preventDefault();
    /* focus goes back to the card on close only for keyboard users: after a
       mouse or touch open, Safari drew the focus ring as a white frame over
       the photograph */
    var focusBack = event.detail === 0 ? link : null;
    fetchFull(handle);
    var done = false;
    /* never a dead tap: with no data at all (search results carry no inline
       payload) wait for the fetch, and if it fails follow the real link */
    var go = function () {
      if (done) return;
      if (!DATA[handle]) return;          // still loading: the fetch callback will call go()
      done = true;
      open(handle, img, focusBack);
    };
    Promise.resolve(fetchFull(handle)).then(function (d) {
      if (!d && !DATA[handle]) { if (link) window.location.href = link.href; return; }
      /* arrived after the 350 ms fallback opened the inline version: upgrade in place */
      if (done && d && dialog.open && currentHandle === handle && track.children.length < d.media.length) {
        populate(handle);
        goTo(0, true);
      }
      go();
    });
    setTimeout(go, 350);
  });

  closeBtn.addEventListener('click', close);
  prevBtn.addEventListener('click', function () { step(-1); });
  nextBtn.addEventListener('click', function () { step(1); });

  // Native <dialog> already closes on Escape and fires 'close'; clicking the
  // backdrop (a click that lands on the <dialog> element itself, not the
  // panel inside it) is the one thing it does not do for free.
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', function () {
    if (opener) { opener.focus(); opener = null; }
    document.documentElement.classList.remove('cc-qv-open');
  });
  dialog.addEventListener('cancel', function (event) {
    // Escape fires 'cancel' before 'close' - route it through the same
    // transition-wrapped close so Escape gets the same morph-back as the X.
    if (!supportsVT) return;
    event.preventDefault();
    close();
  });
  dialog.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowRight') step(1);
    if (event.key === 'ArrowLeft') step(-1);
  });

})();
